export function scrollToTop() {
    document.documentElement.scrollTop = 0
}